import { render, staticRenderFns } from "./VxOutput.vue?vue&type=template&id=340cdaf5&lang=html"
import script from "./VxOutput.vue?vue&type=script&lang=js"
export * from "./VxOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports